(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["G2000-product-slider-v2"] && !Shopify.designMode) return;
  try {
    
// JavaScript (Assuming the version from your last "完整代碼" request which had working drag and scroll)
// No changes were requested to the JS for these specific CSS/Schema updates.
// For brevity, I'm not re-pasting the entire JS block if it was working correctly for you.
// If you need the full JS again, please let me know.
// The key is that the Liquid, CSS, HTML, and Schema are updated as shown above.
// Pasting the JS from the previous full working version:
document.addEventListener('DOMContentLoaded', () => {
  const selectors = {
    section: '[data-section-type="g2000-product-slider-v2"]',
    viewport: '.g2k-product-slider-viewport',
    track: '.g2k-product-slider-track',
    items: '.g2k-product-item',
    navPrev: '.g2k-slider-nav--prev',
    navNext: '.g2k-slider-nav--next'
  };

  class G2000ProductSlider {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.settings = this.getSectionSettings();

      this.viewport = container.querySelector(selectors.viewport);
      this.track = container.querySelector(selectors.track);

      if (!this.track || !this.viewport ) {
        return;
      }

      this.items = Array.from(this.track.querySelectorAll(selectors.items));
      this.navPrev = container.querySelector(selectors.navPrev);
      this.navNext = container.querySelector(selectors.navNext);

      this.currentIndex = 0;
      this.itemRenderedWidth = 0;
      this.gapWidth = 0;
      this.effectiveSlotWidth = 0;
      this.itemsVisible = 0;
      this.totalItems = this.items.length;
      this.currentTranslateX = 0;

      // Infinite scroll properties
      this.originalItemCount = 0;
      this.repeatTimes = 1;
      this.isInfiniteMode = false;
      this.setupInfiniteScroll();

      this.isAutoScrolling = false;
      this.autoScrollInterval = null;
      this.directionChangeInterval = null;
      this.currentScrollDirection = 1;

      this.isDragging = false;
      this.startX = 0;
      this.prevTranslateXOnDragStart = 0;
      this.dragThreshold = 30;

      this.autoResumeTimer = null;
      this.autoResumeDelay = 3000;

      this.init();
    }

    getSectionSettings() {
        let settings = {};
        try {
            const settingsElement = document.getElementById(`shopify-section-settings-${this.sectionId}`);
            if (settingsElement && settingsElement.textContent) {
                settings = JSON.parse(settingsElement.textContent);
            } else {
                settings.scroll_behavior = this.container.dataset.scrollBehavior || 'none';
                settings.constant_scroll_speed = parseInt(this.container.dataset.constantScrollSpeed) || 50;
                settings.sort_by = this.container.dataset.sortBy || 'manual';
            }
        } catch (e) {
            settings = { scroll_behavior: 'none', constant_scroll_speed: 50, sort_by: 'manual' };
        }
        return {
            sort_by: settings.sort_by || 'manual',
            scroll_behavior: settings.scroll_behavior || 'none',
            constant_scroll_speed: !isNaN(parseFloat(settings.constant_scroll_speed)) ? parseFloat(settings.constant_scroll_speed) : 50,
            ...settings
        };
    }

    setupInfiniteScroll() {
        // Detect if we have repeated content for infinite scrolling
        const firstItem = this.items[0];
        if (firstItem && firstItem.dataset.repeatIndex) {
            this.isInfiniteMode = true;

            // Count original items (items with repeat-index="1")
            this.originalItemCount = this.items.filter(item =>
                item.dataset.repeatIndex === "1"
            ).length;

            // Calculate repeat times
            this.repeatTimes = Math.ceil(this.totalItems / this.originalItemCount);
        } else {
            this.isInfiniteMode = false;
            this.originalItemCount = this.totalItems;
            this.repeatTimes = 1;
        }
    }

    calculateDimensions() {
      this.items = Array.from(this.track.querySelectorAll(selectors.items));
      this.totalItems = this.items.length;

      if (this.items.length === 0 || !this.viewport || !this.track) {
        this.itemRenderedWidth = 0; this.gapWidth = 0; this.effectiveSlotWidth = 0; this.itemsVisible = 0;
        this.currentTranslateX = 0;
        if(this.track) this.applyTransform(false);
        this.updateNavVisibility();
        return;
      }
      this.itemRenderedWidth = this.items[0].offsetWidth;
      this.gapWidth = parseFloat(getComputedStyle(this.track).gap || 0);
      if (isNaN(this.gapWidth)) this.gapWidth = 0;
      this.effectiveSlotWidth = this.itemRenderedWidth + this.gapWidth;

      if (this.effectiveSlotWidth > 0) {
        this.itemsVisible = Math.floor((this.viewport.offsetWidth + this.gapWidth) / this.effectiveSlotWidth);
      } else {
        this.itemsVisible = 1;
      }

      const maxIndex = Math.max(0, this.totalItems - this.itemsVisible);
      this.currentIndex = Math.max(0, Math.min(this.currentIndex, maxIndex));

      this.currentTranslateX = -this.currentIndex * this.effectiveSlotWidth;
      this.applyTransform(false);
    }

    applyTransform(animate = true) {
        if (!this.track) return;
        if (!isFinite(this.currentTranslateX)) this.currentTranslateX = 0;
        this.track.style.transition = animate ? 'transform 0.3s ease-out' : 'none';
        this.track.style.transform = `translateX(${this.currentTranslateX}px)`;
    }

    init() {
      this.calculateDimensions();
      this.updateNavVisibility();
      this.bindEvents();

      if (this.settings.sort_by === 'random' && this.items.length > 0) {
        this.shuffleItems();
      }
      if (this.items.length > 0 && this.settings.scroll_behavior !== 'none') {
          this.setupAutoScroll();
      }
      this.checkItemsFit();
    }

    handleManualInteraction() {
        if (this.isAutoScrolling) this.stopAutoScroll();
        clearTimeout(this.autoResumeTimer);
        this.autoResumeTimer = setTimeout(() => {
            if (this.settings.scroll_behavior !== 'none' && !this.isDragging && this.items.length > 0) {
                this.setupAutoScroll();
            }
        }, this.autoResumeDelay);
    }

    dragStart(event) {
        if (this.items.length === 0 || (this.itemsVisible > 0 && this.totalItems <= this.itemsVisible)) return;
        this.handleManualInteraction();
        this.isDragging = true;
        this.startX = event.type.includes('touch') ? event.touches[0].pageX : event.pageX;
        this.prevTranslateXOnDragStart = this.currentTranslateX;
        this.track.style.transition = 'none';
        this.viewport.classList.add('is-dragging');
        document.body.style.userSelect = 'none';
    }

    dragMove(event) {
        if (!this.isDragging) return;
        const currentX = event.type.includes('touch') ? event.touches[0].pageX : event.pageX;
        let diffX = currentX - this.startX;

        if (event.type.includes('touch')) {
            if (typeof this.touchStartY === 'undefined') this.touchStartY = event.touches[0].pageY;
            const diffY = event.touches[0].pageY - this.touchStartY;
            if (Math.abs(diffX) > Math.abs(diffY) + 5 ) {
                event.preventDefault();
            } else {
                return;
            }
        }
        this.currentTranslateX = this.prevTranslateXOnDragStart + diffX;
        this.applyTransform(false);
    }

    dragEnd() {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.viewport.classList.remove('is-dragging');
        document.body.style.userSelect = '';
        delete this.touchStartY;

        if (this.isInfiniteMode) {
            // Handle infinite scroll positioning
            let targetIndex = Math.round(-this.currentTranslateX / this.effectiveSlotWidth);

            // Normalize to original item range
            if (targetIndex >= this.totalItems) {
                targetIndex = targetIndex % this.originalItemCount;
                this.currentTranslateX = -targetIndex * this.effectiveSlotWidth;
            } else if (targetIndex < 0) {
                targetIndex = this.originalItemCount + (targetIndex % this.originalItemCount);
                this.currentTranslateX = -targetIndex * this.effectiveSlotWidth;
            }

            this.currentIndex = targetIndex;
        } else {
            let targetIndex = Math.round(-this.currentTranslateX / this.effectiveSlotWidth);
            const maxIndex = Math.max(0, this.totalItems - (this.itemsVisible > 0 ? this.itemsVisible : 1) );

            this.currentIndex = Math.max(0, Math.min(targetIndex, maxIndex));
            this.currentTranslateX = -this.currentIndex * this.effectiveSlotWidth;
        }

        this.scrollToCurrent(true);
        this.handleManualInteraction();
    }

    bindEvents() {
      if (this.navPrev) {
        this.navPrev.addEventListener('click', () => { this.handleManualInteraction(); this.navigate(-1); });
      }
      if (this.navNext) {
        this.navNext.addEventListener('click', () => { this.handleManualInteraction(); this.navigate(1); });
      }
      this.debouncedResizeHandler = this.debounce(this.onResize.bind(this), 200);
      window.addEventListener('resize', this.debouncedResizeHandler);
      document.addEventListener('shopify:section:load', this.handleSectionEvent.bind(this));
      document.addEventListener('shopify:section:unload', this.handleSectionEvent.bind(this));
      document.addEventListener('shopify:section:select', this.handleSectionEvent.bind(this));
      document.addEventListener('shopify:section:deselect', this.handleSectionEvent.bind(this));
      this.viewport.addEventListener('mousedown', this.dragStart.bind(this));
      document.addEventListener('mousemove', this.dragMove.bind(this));
      document.addEventListener('mouseup', this.dragEnd.bind(this));
      document.addEventListener('mouseleave', this.dragEnd.bind(this));
      this.viewport.addEventListener('touchstart', this.dragStart.bind(this), { passive: true });
      this.viewport.addEventListener('touchmove', this.dragMove.bind(this), { passive: false });
      this.viewport.addEventListener('touchend', this.dragEnd.bind(this));
      this.viewport.addEventListener('touchcancel', this.dragEnd.bind(this));
    }

    handleSectionEvent(event) {
        if (event.detail.sectionId === this.sectionId) {
            if (event.type === 'shopify:section:unload' || event.type === 'shopify:section:deselect' ) {
                this.destroy();
            } else {
                setTimeout(() => { this.onSectionLoadOrSelect(); }, 150);
            }
        }
    }
    onResize() { this.calculateDimensions(); this.checkItemsFit(); } // Modified to call checkItemsFit
    navigate(direction) {
        if (this.items.length === 0) return;

        if (this.isInfiniteMode) {
            // Infinite scroll navigation
            let newIndex = this.currentIndex + direction;

            // Handle wrapping for infinite scroll
            if (newIndex >= this.totalItems) {
                newIndex = newIndex % this.originalItemCount;
            } else if (newIndex < 0) {
                newIndex = this.originalItemCount + (newIndex % this.originalItemCount);
            }

            this.currentIndex = newIndex;
            this.currentTranslateX = -this.currentIndex * this.effectiveSlotWidth;
        } else {
            // Regular navigation with boundaries
            if (this.itemsVisible > 0 && this.totalItems <= this.itemsVisible) return;
            let newIndex = this.currentIndex + direction;
            const maxIndex = Math.max(0, this.totalItems - (this.itemsVisible > 0 ? this.itemsVisible : 1));
            newIndex = Math.max(0, Math.min(newIndex, maxIndex));
            this.currentIndex = newIndex;
            this.currentTranslateX = -this.currentIndex * this.effectiveSlotWidth;
        }

        this.scrollToCurrent(true);
    }
    scrollToCurrent(animate = true) { this.applyTransform(animate); this.updateNavVisibility(); }
    updateNavVisibility() {
        if (!this.navPrev || !this.navNext || this.items.length === 0 ) {
            if(this.navPrev) this.navPrev.style.display = 'none';
            if(this.navNext) this.navNext.style.display = 'none';
            return;
        }

        const viewportWidth = this.viewport.offsetWidth;
        const totalTrackWidth = this.track.scrollWidth;

        if (this.isInfiniteMode) {
            // In infinite mode, always show navigation if we have content
            if (this.originalItemCount > 0) {
                this.navPrev.style.display = 'block';
                this.navNext.style.display = 'block';
                this.navPrev.style.opacity = '1';
                this.navPrev.style.pointerEvents = 'auto';
                this.navNext.style.opacity = '1';
                this.navNext.style.pointerEvents = 'auto';
            } else {
                this.navPrev.style.display = 'none';
                this.navNext.style.display = 'none';
            }
        } else {
            // Regular mode with boundaries
            if (totalTrackWidth <= viewportWidth + 1 ) {
                this.navPrev.style.display = 'none';
                this.navNext.style.display = 'none';
                return;
            } else {
                this.navPrev.style.display = 'block';
                this.navNext.style.display = 'block';
            }
            const epsilon = 1;
            this.navPrev.style.opacity = this.currentTranslateX >= -epsilon ? '0.5' : '1';
            this.navPrev.style.pointerEvents = this.currentTranslateX >= -epsilon ? 'none' : 'auto';
            const minTranslateX = -(totalTrackWidth - viewportWidth);
            this.navNext.style.opacity = this.currentTranslateX <= minTranslateX + epsilon ? '0.5' : '1';
            this.navNext.style.pointerEvents = this.currentTranslateX <= minTranslateX + epsilon ? 'none' : 'auto';
        }
    }
    setupAutoScroll() {
        this.stopAutoScroll();
        if (this.settings.scroll_behavior === 'none' || typeof window.requestAnimationFrame === 'undefined' || this.items.length === 0) {
            this.isAutoScrolling = false; return;
        }
        const viewportWidth = this.viewport.offsetWidth;
        const totalTrackWidth = this.track.scrollWidth;

        // For infinite mode, always allow auto scroll if we have content
        if (!this.isInfiniteMode && totalTrackWidth <= viewportWidth + 1) {
            this.isAutoScrolling = false; return;
        }

        this.isAutoScrolling = true;
        let currentPosition = this.currentTranslateX;
        let lastTime = performance.now();
        if (this.settings.scroll_behavior === 'auto_change_direction') { this.currentScrollDirection = 1; }

        const scrollStep = (currentTime) => {
            if (!this.isAutoScrolling || !this.track) return;
            const deltaTime = (currentTime - lastTime) / 1000;
            lastTime = currentTime;
            let speedPxPerSec = parseFloat(this.settings.constant_scroll_speed);
            let scrollAmount = speedPxPerSec * deltaTime;

            if (this.isInfiniteMode) {
                // Infinite scroll auto-scrolling
                const originalTrackWidth = this.originalItemCount * this.effectiveSlotWidth;

                if (this.settings.scroll_behavior === 'auto_left_loop' || (this.settings.scroll_behavior === 'auto_change_direction' && this.currentScrollDirection === 1)) {
                    currentPosition -= scrollAmount;
                    if (currentPosition <= -originalTrackWidth) {
                        currentPosition = 0; // Seamless loop back to start
                    }
                } else if (this.settings.scroll_behavior === 'auto_right_loop' || (this.settings.scroll_behavior === 'auto_change_direction' && this.currentScrollDirection === -1)) {
                    currentPosition += scrollAmount;
                    if (currentPosition >= 0) {
                        currentPosition = -originalTrackWidth; // Seamless loop back to end
                    }
                }
            } else {
                // Regular auto-scrolling with boundaries
                const minTranslateXScroll = -(totalTrackWidth - viewportWidth);
                if (this.settings.scroll_behavior === 'auto_left_loop' || (this.settings.scroll_behavior === 'auto_change_direction' && this.currentScrollDirection === 1)) {
                  currentPosition -= scrollAmount;
                  if (currentPosition < minTranslateXScroll && totalTrackWidth > viewportWidth) { currentPosition = 0; }
                  else if (currentPosition < minTranslateXScroll) { currentPosition = minTranslateXScroll; }
                } else if (this.settings.scroll_behavior === 'auto_right_loop' || (this.settings.scroll_behavior === 'auto_change_direction' && this.currentScrollDirection === -1)) {
                   currentPosition += scrollAmount;
                   if (currentPosition > 0 && totalTrackWidth > viewportWidth) { currentPosition = minTranslateXScroll; }
                   else if (currentPosition > 0) { currentPosition = 0;}
                }
            }

            this.track.style.transition = 'none';
            this.track.style.transform = `translateX(${currentPosition}px)`;
            this.currentTranslateX = currentPosition;
            this.updateNavVisibility();
            this.autoScrollInterval = requestAnimationFrame(scrollStep);
        };
        this.autoScrollInterval = requestAnimationFrame(scrollStep);
        if (this.settings.scroll_behavior === 'auto_change_direction') {
            this.directionChangeInterval = setInterval(() => { this.currentScrollDirection *= -1; }, 10000);
        }
    }
    stopAutoScroll() {
        this.isAutoScrolling = false;
        if (this.autoScrollInterval) cancelAnimationFrame(this.autoScrollInterval);
        if (this.directionChangeInterval) clearInterval(this.directionChangeInterval);
        this.autoScrollInterval = null; this.directionChangeInterval = null;
    }
    debounce(func, wait) {
      let timeout;
      return (...args) => {
        const context = this; clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }
    shuffleItems() {
        if (this.items.length === 0) return;
        for (let i = this.items.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [this.items[i], this.items[j]] = [this.items[j], this.items[i]];
        }
        this.track.innerHTML = '';
        this.items.forEach(item => this.track.appendChild(item));
    }
    checkItemsFit() {
        if (this.items.length === 0 || !this.effectiveSlotWidth || this.effectiveSlotWidth === 0) {
             if(this.navPrev) this.navPrev.style.display = 'none';
             if(this.navNext) this.navNext.style.display = 'none';
             this.stopAutoScroll();
            return;
        }
        const viewportWidth = this.viewport.offsetWidth;
        const totalTrackWidth = this.track.scrollWidth;

        if (totalTrackWidth <= viewportWidth + 1) {
            if(this.navPrev) this.navPrev.style.display = 'none';
            if(this.navNext) this.navNext.style.display = 'none';
            this.stopAutoScroll();
        } else {
            this.updateNavVisibility();
            if (this.settings.scroll_behavior !== 'none' && !this.isAutoScrolling) {
                 this.setupAutoScroll();
            }
        }
    }
    onSectionLoadOrSelect() {
        this.settings = this.getSectionSettings();
        this.viewport = this.container.querySelector(selectors.viewport);
        this.track = this.container.querySelector(selectors.track);
        if (!this.track || !this.viewport) { return; }
        this.navPrev = this.container.querySelector(selectors.navPrev);
        this.navNext = this.container.querySelector(selectors.navNext);
        this.currentIndex = 0;
        this.currentTranslateX = 0;
        this.stopAutoScroll();
        this.init();
    }
    destroy() {
        this.stopAutoScroll();
        if (this.debouncedResizeHandler) {
            window.removeEventListener('resize', this.debouncedResizeHandler);
        }
        // Remove event listeners from document and viewport to prevent memory leaks
        if(this.viewport){
            this.viewport.removeEventListener('mousedown', this.dragStart.bind(this));
            this.viewport.removeEventListener('touchstart', this.dragStart.bind(this));
            this.viewport.removeEventListener('touchmove', this.dragMove.bind(this));
            this.viewport.removeEventListener('touchend', this.dragEnd.bind(this));
            this.viewport.removeEventListener('touchcancel', this.dragEnd.bind(this));
        }
        document.removeEventListener('mousemove', this.dragMove.bind(this));
        document.removeEventListener('mouseup', this.dragEnd.bind(this));
        document.removeEventListener('mouseleave', this.dragEnd.bind(this));

        document.removeEventListener('shopify:section:load', this.handleSectionEvent.bind(this));
        document.removeEventListener('shopify:section:unload', this.handleSectionEvent.bind(this));
        document.removeEventListener('shopify:section:select', this.handleSectionEvent.bind(this));
        document.removeEventListener('shopify:section:deselect', this.handleSectionEvent.bind(this));

        if (this.container && this.container.g2000SliderInstance) {
            this.container.g2000SliderInstance = null;
        }
    }
  }

  function initializeAllSliders() {
      const sliderContainers = document.querySelectorAll(selectors.section);
      sliderContainers.forEach(container => {
          if (container.g2000SliderInstance && typeof container.g2000SliderInstance.destroy === 'function') {
              container.g2000SliderInstance.destroy();
          }
          container.g2000SliderInstance = new G2000ProductSlider(container);
      });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initializeAllSliders); } else { initializeAllSliders(); }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const sectionElement = event.target.classList.contains('shopify-section') ? event.target : event.target.closest('.shopify-section');
        if (sectionElement) {
            const sliderContainer = sectionElement.querySelector(`[data-section-id="${event.detail.sectionId}"]${selectors.section}`);
            if (sliderContainer) {
                if (sliderContainer.g2000SliderInstance && typeof sliderContainer.g2000SliderInstance.destroy === 'function') {
                    sliderContainer.g2000SliderInstance.destroy();
                }
                sliderContainer.g2000SliderInstance = new G2000ProductSlider(sliderContainer);
            }
        }
    });
    document.addEventListener('shopify:section:reorder', initializeAllSliders);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["G2000-product-slider"] && !Shopify.designMode) return;
  try {
    
// JavaScript (Assuming the version from your last "完整代碼" request which had working drag and scroll)
// No changes were requested to the JS for these specific CSS/Schema updates.
// For brevity, I'm not re-pasting the entire JS block if it was working correctly for you.
// If you need the full JS again, please let me know.
// The key is that the Liquid, CSS, HTML, and Schema are updated as shown above.
// Pasting the JS from the previous full working version:
document.addEventListener('DOMContentLoaded', () => {
  const selectors = {
    section: '[data-section-type="g2000-product-slider"]',
    viewport: '.g2k-product-slider-viewport',
    track: '.g2k-product-slider-track',
    items: '.g2k-product-item',
    navPrev: '.g2k-slider-nav--prev',
    navNext: '.g2k-slider-nav--next'
  };

  class G2000ProductSlider {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.settings = this.getSectionSettings();

      this.viewport = container.querySelector(selectors.viewport);
      this.track = container.querySelector(selectors.track);

      if (!this.track || !this.viewport ) {
        return;
      }

      this.items = Array.from(this.track.querySelectorAll(selectors.items));
      this.navPrev = container.querySelector(selectors.navPrev);
      this.navNext = container.querySelector(selectors.navNext);

      this.currentIndex = 0;
      this.itemRenderedWidth = 0;
      this.gapWidth = 0;
      this.effectiveSlotWidth = 0;
      this.itemsVisible = 0;
      this.totalItems = this.items.length;
      this.currentTranslateX = 0;

      this.isAutoScrolling = false;
      this.autoScrollInterval = null;
      this.directionChangeInterval = null;
      this.currentScrollDirection = 1;

      this.isDragging = false;
      this.startX = 0;
      this.prevTranslateXOnDragStart = 0;
      this.dragThreshold = 30;

      this.autoResumeTimer = null;
      this.autoResumeDelay = 3000;

      this.init();
    }

    getSectionSettings() {
        let settings = {};
        try {
            const settingsElement = document.getElementById(`shopify-section-settings-${this.sectionId}`);
            if (settingsElement && settingsElement.textContent) {
                settings = JSON.parse(settingsElement.textContent);
            } else {
                settings.scroll_behavior = this.container.dataset.scrollBehavior || 'none';
                settings.constant_scroll_speed = parseInt(this.container.dataset.constantScrollSpeed) || 50;
                settings.sort_by = this.container.dataset.sortBy || 'manual';
            }
        } catch (e) {
            settings = { scroll_behavior: 'none', constant_scroll_speed: 50, sort_by: 'manual' };
        }
        return {
            sort_by: settings.sort_by || 'manual',
            scroll_behavior: settings.scroll_behavior || 'none',
            constant_scroll_speed: !isNaN(parseFloat(settings.constant_scroll_speed)) ? parseFloat(settings.constant_scroll_speed) : 50,
            ...settings
        };
    }

    calculateDimensions() {
      this.items = Array.from(this.track.querySelectorAll(selectors.items));
      this.totalItems = this.items.length;

      if (this.items.length === 0 || !this.viewport || !this.track) {
        this.itemRenderedWidth = 0; this.gapWidth = 0; this.effectiveSlotWidth = 0; this.itemsVisible = 0;
        this.currentTranslateX = 0;
        if(this.track) this.applyTransform(false);
        this.updateNavVisibility();
        return;
      }
      this.itemRenderedWidth = this.items[0].offsetWidth;
      this.gapWidth = parseFloat(getComputedStyle(this.track).gap || 0);
      if (isNaN(this.gapWidth)) this.gapWidth = 0;
      this.effectiveSlotWidth = this.itemRenderedWidth + this.gapWidth;

      if (this.effectiveSlotWidth > 0) {
        this.itemsVisible = Math.floor((this.viewport.offsetWidth + this.gapWidth) / this.effectiveSlotWidth);
      } else {
        this.itemsVisible = 1;
      }

      const maxIndex = Math.max(0, this.totalItems - this.itemsVisible);
      this.currentIndex = Math.max(0, Math.min(this.currentIndex, maxIndex));

      this.currentTranslateX = -this.currentIndex * this.effectiveSlotWidth;
      this.applyTransform(false);
    }

    applyTransform(animate = true) {
        if (!this.track) return;
        if (!isFinite(this.currentTranslateX)) this.currentTranslateX = 0;
        this.track.style.transition = animate ? 'transform 0.3s ease-out' : 'none';
        this.track.style.transform = `translateX(${this.currentTranslateX}px)`;
    }

    init() {
      this.calculateDimensions();
      this.updateNavVisibility();
      this.bindEvents();

      if (this.settings.sort_by === 'random' && this.items.length > 0) {
        this.shuffleItems();
      }
      if (this.items.length > 0 && this.settings.scroll_behavior !== 'none') {
          this.setupAutoScroll();
      }
      this.checkItemsFit();
    }

    handleManualInteraction() {
        if (this.isAutoScrolling) this.stopAutoScroll();
        clearTimeout(this.autoResumeTimer);
        this.autoResumeTimer = setTimeout(() => {
            if (this.settings.scroll_behavior !== 'none' && !this.isDragging && this.items.length > 0) {
                this.setupAutoScroll();
            }
        }, this.autoResumeDelay);
    }

    dragStart(event) {
        if (this.items.length === 0 || (this.itemsVisible > 0 && this.totalItems <= this.itemsVisible)) return;
        this.handleManualInteraction();
        this.isDragging = true;
        this.startX = event.type.includes('touch') ? event.touches[0].pageX : event.pageX;
        this.prevTranslateXOnDragStart = this.currentTranslateX;
        this.track.style.transition = 'none';
        this.viewport.classList.add('is-dragging');
        document.body.style.userSelect = 'none';
    }

    dragMove(event) {
        if (!this.isDragging) return;
        const currentX = event.type.includes('touch') ? event.touches[0].pageX : event.pageX;
        let diffX = currentX - this.startX;

        if (event.type.includes('touch')) {
            if (typeof this.touchStartY === 'undefined') this.touchStartY = event.touches[0].pageY;
            const diffY = event.touches[0].pageY - this.touchStartY;
            if (Math.abs(diffX) > Math.abs(diffY) + 5 ) {
                event.preventDefault();
            } else {
                return;
            }
        }
        this.currentTranslateX = this.prevTranslateXOnDragStart + diffX;
        this.applyTransform(false);
    }

    dragEnd() {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.viewport.classList.remove('is-dragging');
        document.body.style.userSelect = '';
        delete this.touchStartY;

        let targetIndex = Math.round(-this.currentTranslateX / this.effectiveSlotWidth);
        const maxIndex = Math.max(0, this.totalItems - (this.itemsVisible > 0 ? this.itemsVisible : 1) );

        this.currentIndex = Math.max(0, Math.min(targetIndex, maxIndex));
        this.currentTranslateX = -this.currentIndex * this.effectiveSlotWidth;
        this.scrollToCurrent(true);
        this.handleManualInteraction();
    }

    bindEvents() {
      if (this.navPrev) {
        this.navPrev.addEventListener('click', () => { this.handleManualInteraction(); this.navigate(-1); });
      }
      if (this.navNext) {
        this.navNext.addEventListener('click', () => { this.handleManualInteraction(); this.navigate(1); });
      }
      this.debouncedResizeHandler = this.debounce(this.onResize.bind(this), 200);
      window.addEventListener('resize', this.debouncedResizeHandler);
      document.addEventListener('shopify:section:load', this.handleSectionEvent.bind(this));
      document.addEventListener('shopify:section:unload', this.handleSectionEvent.bind(this));
      document.addEventListener('shopify:section:select', this.handleSectionEvent.bind(this));
      document.addEventListener('shopify:section:deselect', this.handleSectionEvent.bind(this));
      this.viewport.addEventListener('mousedown', this.dragStart.bind(this));
      document.addEventListener('mousemove', this.dragMove.bind(this));
      document.addEventListener('mouseup', this.dragEnd.bind(this));
      document.addEventListener('mouseleave', this.dragEnd.bind(this));
      this.viewport.addEventListener('touchstart', this.dragStart.bind(this), { passive: true });
      this.viewport.addEventListener('touchmove', this.dragMove.bind(this), { passive: false });
      this.viewport.addEventListener('touchend', this.dragEnd.bind(this));
      this.viewport.addEventListener('touchcancel', this.dragEnd.bind(this));
    }

    handleSectionEvent(event) {
        if (event.detail.sectionId === this.sectionId) {
            if (event.type === 'shopify:section:unload' || event.type === 'shopify:section:deselect' ) {
                this.destroy();
            } else {
                setTimeout(() => { this.onSectionLoadOrSelect(); }, 150);
            }
        }
    }
    onResize() { this.calculateDimensions(); this.checkItemsFit(); } // Modified to call checkItemsFit
    navigate(direction) {
        if (this.items.length === 0 || (this.itemsVisible > 0 && this.totalItems <= this.itemsVisible) ) return;
        let newIndex = this.currentIndex + direction;
        const maxIndex = Math.max(0, this.totalItems - (this.itemsVisible > 0 ? this.itemsVisible : 1));
        newIndex = Math.max(0, Math.min(newIndex, maxIndex));
        this.currentIndex = newIndex;
        this.currentTranslateX = -this.currentIndex * this.effectiveSlotWidth;
        this.scrollToCurrent(true);
    }
    scrollToCurrent(animate = true) { this.applyTransform(animate); this.updateNavVisibility(); }
    updateNavVisibility() {
        if (!this.navPrev || !this.navNext || this.items.length === 0 ) {
            if(this.navPrev) this.navPrev.style.display = 'none';
            if(this.navNext) this.navNext.style.display = 'none';
            return;
        }
        const viewportWidth = this.viewport.offsetWidth;
        const totalTrackWidth = this.track.scrollWidth;
        if (totalTrackWidth <= viewportWidth + 1 ) {
            this.navPrev.style.display = 'none'; this.navNext.style.display = 'none'; return;
        } else {
            this.navPrev.style.display = 'block'; this.navNext.style.display = 'block';
        }
        const epsilon = 1;
        this.navPrev.style.opacity = this.currentTranslateX >= -epsilon ? '0.5' : '1';
        this.navPrev.style.pointerEvents = this.currentTranslateX >= -epsilon ? 'none' : 'auto';
        const minTranslateX = -(totalTrackWidth - viewportWidth);
        this.navNext.style.opacity = this.currentTranslateX <= minTranslateX + epsilon ? '0.5' : '1';
        this.navNext.style.pointerEvents = this.currentTranslateX <= minTranslateX + epsilon ? 'none' : 'auto';
    }
    setupAutoScroll() {
        this.stopAutoScroll();
        if (this.settings.scroll_behavior === 'none' || typeof window.requestAnimationFrame === 'undefined' || this.items.length === 0) {
            this.isAutoScrolling = false; return;
        }
        const viewportWidth = this.viewport.offsetWidth;
        const totalTrackWidth = this.track.scrollWidth;
        if (totalTrackWidth <= viewportWidth +1 ) { this.isAutoScrolling = false; return; }
        this.isAutoScrolling = true;
        let currentPosition = this.currentTranslateX;
        let lastTime = performance.now();
        if (this.settings.scroll_behavior === 'auto_change_direction') { this.currentScrollDirection = 1; }
        const scrollStep = (currentTime) => {
            if (!this.isAutoScrolling || !this.track) return;
            const deltaTime = (currentTime - lastTime) / 1000;
            lastTime = currentTime;
            let speedPxPerSec = parseFloat(this.settings.constant_scroll_speed);
            let scrollAmount = speedPxPerSec * deltaTime;
            const minTranslateXScroll = -(totalTrackWidth - viewportWidth);
            if (this.settings.scroll_behavior === 'auto_left_loop' || (this.settings.scroll_behavior === 'auto_change_direction' && this.currentScrollDirection === 1)) {
              currentPosition -= scrollAmount;
              if (currentPosition < minTranslateXScroll && totalTrackWidth > viewportWidth) { currentPosition = 0; } // Loop to start only if scrollable
              else if (currentPosition < minTranslateXScroll) { currentPosition = minTranslateXScroll; } // Stick to end if not enough to loop
            } else if (this.settings.scroll_behavior === 'auto_right_loop' || (this.settings.scroll_behavior === 'auto_change_direction' && this.currentScrollDirection === -1)) {
               currentPosition += scrollAmount;
               if (currentPosition > 0 && totalTrackWidth > viewportWidth) { currentPosition = minTranslateXScroll; } // Loop to end only if scrollable
               else if (currentPosition > 0) { currentPosition = 0;} // Stick to start
            }
            this.track.style.transition = 'none';
            this.track.style.transform = `translateX(${currentPosition}px)`;
            this.currentTranslateX = currentPosition;
            this.updateNavVisibility();
            this.autoScrollInterval = requestAnimationFrame(scrollStep);
        };
        this.autoScrollInterval = requestAnimationFrame(scrollStep);
        if (this.settings.scroll_behavior === 'auto_change_direction') {
            this.directionChangeInterval = setInterval(() => { this.currentScrollDirection *= -1; }, 10000);
        }
    }
    stopAutoScroll() {
        this.isAutoScrolling = false;
        if (this.autoScrollInterval) cancelAnimationFrame(this.autoScrollInterval);
        if (this.directionChangeInterval) clearInterval(this.directionChangeInterval);
        this.autoScrollInterval = null; this.directionChangeInterval = null;
    }
    debounce(func, wait) {
      let timeout;
      return (...args) => {
        const context = this; clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }
    shuffleItems() {
        if (this.items.length === 0) return;
        for (let i = this.items.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [this.items[i], this.items[j]] = [this.items[j], this.items[i]];
        }
        this.track.innerHTML = '';
        this.items.forEach(item => this.track.appendChild(item));
    }
    checkItemsFit() {
        if (this.items.length === 0 || !this.effectiveSlotWidth || this.effectiveSlotWidth === 0) {
             if(this.navPrev) this.navPrev.style.display = 'none';
             if(this.navNext) this.navNext.style.display = 'none';
             this.stopAutoScroll();
            return;
        }
        const viewportWidth = this.viewport.offsetWidth;
        const totalTrackWidth = this.track.scrollWidth;

        if (totalTrackWidth <= viewportWidth + 1) {
            if(this.navPrev) this.navPrev.style.display = 'none';
            if(this.navNext) this.navNext.style.display = 'none';
            this.stopAutoScroll();
        } else {
            this.updateNavVisibility();
            if (this.settings.scroll_behavior !== 'none' && !this.isAutoScrolling) {
                 this.setupAutoScroll();
            }
        }
    }
    onSectionLoadOrSelect() {
        this.settings = this.getSectionSettings();
        this.viewport = this.container.querySelector(selectors.viewport);
        this.track = this.container.querySelector(selectors.track);
        if (!this.track || !this.viewport) { return; }
        this.navPrev = this.container.querySelector(selectors.navPrev);
        this.navNext = this.container.querySelector(selectors.navNext);
        this.currentIndex = 0;
        this.currentTranslateX = 0;
        this.stopAutoScroll();
        this.init();
    }
    destroy() {
        this.stopAutoScroll();
        if (this.debouncedResizeHandler) {
            window.removeEventListener('resize', this.debouncedResizeHandler);
        }
        // Remove event listeners from document and viewport to prevent memory leaks
        if(this.viewport){
            this.viewport.removeEventListener('mousedown', this.dragStart.bind(this));
            this.viewport.removeEventListener('touchstart', this.dragStart.bind(this));
            this.viewport.removeEventListener('touchmove', this.dragMove.bind(this));
            this.viewport.removeEventListener('touchend', this.dragEnd.bind(this));
            this.viewport.removeEventListener('touchcancel', this.dragEnd.bind(this));
        }
        document.removeEventListener('mousemove', this.dragMove.bind(this));
        document.removeEventListener('mouseup', this.dragEnd.bind(this));
        document.removeEventListener('mouseleave', this.dragEnd.bind(this));

        document.removeEventListener('shopify:section:load', this.handleSectionEvent.bind(this));
        document.removeEventListener('shopify:section:unload', this.handleSectionEvent.bind(this));
        document.removeEventListener('shopify:section:select', this.handleSectionEvent.bind(this));
        document.removeEventListener('shopify:section:deselect', this.handleSectionEvent.bind(this));

        if (this.container && this.container.g2000SliderInstance) {
            this.container.g2000SliderInstance = null;
        }
    }
  }

  function initializeAllSliders() {
      const sliderContainers = document.querySelectorAll(selectors.section);
      sliderContainers.forEach(container => {
          if (container.g2000SliderInstance && typeof container.g2000SliderInstance.destroy === 'function') {
              container.g2000SliderInstance.destroy();
          }
          container.g2000SliderInstance = new G2000ProductSlider(container);
      });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initializeAllSliders); } else { initializeAllSliders(); }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const sectionElement = event.target.classList.contains('shopify-section') ? event.target : event.target.closest('.shopify-section');
        if (sectionElement) {
            const sliderContainer = sectionElement.querySelector(`[data-section-id="${event.detail.sectionId}"]${selectors.section}`);
            if (sliderContainer) {
                if (sliderContainer.g2000SliderInstance && typeof sliderContainer.g2000SliderInstance.destroy === 'function') {
                    sliderContainer.g2000SliderInstance.destroy();
                }
                sliderContainer.g2000SliderInstance = new G2000ProductSlider(sliderContainer);
            }
        }
    });
    document.addEventListener('shopify:section:reorder', initializeAllSliders);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
